import { Config } from './../config';
import { Response } from './../response';
import { ContentPortalMapping } from './../content-portal-mapping';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QueryParam } from '../query-param';
import { ApiService } from '../services/api.service';
import { Menu } from '../menu';
import { Title } from '@angular/platform-browser';
import { MobileDialogComponent } from '../mobile-dialog/mobile-dialog.component';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ComvivaDialogComponent } from '../comviva-dialog/comviva-dialog.component';
import { BlockerComponent } from '../blocker/blocker.component';
import { HutchpopupComponent } from '../hutchpopup/hutchpopup.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  menu!: Menu[];
  trendingList!: ContentPortalMapping[];
  recommendList!: ContentPortalMapping[];
  slideConfig: any;
  res!: Response;
  contentList!: ContentPortalMapping[];
  queryParam!: QueryParam;
  requestObj!: QueryParam;

  contentUrl = 'https://1477157375.rsc.cdn77.org/repository/content';
  mobileNumber: any;

  gameConfig: Config = {} as Config;
  dialogRef: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private router: Router,
    private titleService: Title,
    private modal: NgbModal
  ) {
    this.activatedRoute.params.subscribe(params => console.log("4564564565" + JSON.stringify(params)));

  }

  ngOnInit() {
    // debugger;
    // this.getVideoConfig();

    this.trendingList = [];
    this.recommendList = [];
    this.menu = [];
    this.res = {} as Response;
    let storageName = this.apiService.getItem();

    this.queryParam = JSON.parse(
      localStorage.getItem(storageName) || 'undefined'
    );

    console.log("Home Local Storage", localStorage.getItem(storageName));

    this.getQueryParam();

    if(this.queryParam.biller == 'MONDIOMEDIA' && this.queryParam.id == '491' && this.queryParam.operator == '2108'){
      
      if(this.queryParam.code == undefined || this.queryParam.code == null){
          window.location.href = 'http://wap.matrixads.in/mglobopay/ngMondioLogin?serviceid=1292'
      }
    }
    console.log("After Query Home Local Storage", this.queryParam.pin);

    if (this.queryParam.id === '528' && this.queryParam.biller === 'ACTEL' && this.queryParam.operator === '2162') {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openDialog();
      }
    }

    if(this.queryParam.blocker == "1"){
      this.openBlocker();
    }

    if ((this.queryParam.id === '519' || this.queryParam.id === '530' || this.queryParam.id === '447') && this.queryParam.biller === 'COMVIVA' && (this.queryParam.operator === '2022' || this.queryParam.operator === '2029')) {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openDialog_comviva();
      } else {
        // let url = "http://wap.matrixads.in/mglobopay/tpaygamesworldPortalValidation/"+this.queryParam.mobileNumber;
        // return "http://wap.matrixads.in/mglobopay/getSubDataById?serviceid=1313&msisdn=2585537895";
        // this.queryParam.serviceId = '1349';
        let url = "http://wap.matrixads.in/mglobopay/getSubDataById?serviceid=" + this.queryParam.serviceId + "&msisdn=" + mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url);
        console.log("UNSUB DATA", url)
      }
    } else if (this.queryParam.id === '491' && (this.queryParam.operator === '9091' ||this.queryParam.operator=== '9092' || this.queryParam.operator=== '9093') && this.queryParam.biller == 'MESSAGECLOUD') {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openDialog_comviva();
      }
      else {
        // let url = "http://wap.matrixads.in/mglobopay/tpaygamesworldPortalValidation/"+this.queryParam.mobileNumber;
        // return "http://wap.matrixads.in/mglobopay/getSubDataById?serviceid=1313&msisdn=2585537895";
        // this.queryParam.serviceId = '1349';
        let url = "http://wap.matrixads.in/mglobopay/getSubDataById?serviceid=" + this.queryParam.serviceId + "&msisdn=" + mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url);
        console.log("UNSUB DATA", url)
      }

    }
    else if (this.queryParam.id === '375' && this.queryParam.biller == 'QANAWAT') {
      let url = "http://wap.matrixads.in/mglobopay/fccUnsubUrlwap/" + this.queryParam.msisdn + "/" + this.queryParam.serviceName;

      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openDialog();
      }

    }else if(this.queryParam.id === '536' && this.queryParam.biller == 'Mobimind' && (this.queryParam.operator == '9043' || this.queryParam.operator == '2029')){
      let url = "http://wap.matrixads.in/mglobopay/fccUnsubUrlwap/" + this.queryParam.msisdn + "/" + this.queryParam.serviceName;

      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openDialog();
      }
    }else if((this.queryParam.id === '502' ||this.queryParam.id === '503') && this.queryParam.biller == 'Tetragram'){
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openDialog();
      }
    }
    
    this.getConfigData(this.queryParam.id, this.queryParam.lang, this.queryParam.theme);
    this.getMainData();

    this.slideConfig = {
      slidesToShow: 4,
      slidesToScroll: 4,
      speed: 1000,
      autoplay: true
    };
    this.getConditionalDialogBox()
  }

  selectedIndex: number = 0;

  setIndex(index: number) {
    this.selectedIndex = index;
  }



  getMobileRes(mobileNumber: number, url: any) {
    this.apiService.getMobileResponse(url).subscribe(
      (response: any) => {

        let data = JSON.parse(response);
        console.log('JSON.parse(response)', JSON.parse(response));

        if (this.queryParam.id == '447' || this.queryParam.id == '532') {
          if (data.currentStstus == "ACTIVE") {
            response = true;
          } else {
            response = false;
          }
        }
        console.log('Mobile Reponse ===============', response);
        if (response === true) {
          this.setValuesToLocalStorage(mobileNumber)
        }
        else {
          this.openDialog();
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }


  setValuesToLocalStorage(mobileNumber: number) {
    this.mobileNumber = mobileNumber;
    this.queryParam.sub = true;
    this.queryParam.mobileNumber = this.mobileNumber;
    let storageName = this.queryParam.id + this.queryParam.operator + this.queryParam.biller;
    localStorage.setItem(storageName, JSON.stringify(this.queryParam));
  }

  getMainData() {

    this.requestObj = JSON.parse(JSON.stringify(this.queryParam));
    if (this.requestObj.lang == 'PT') {
      this.requestObj.lang = 'EN'
    }



    this.apiService.getData(this.requestObj).subscribe(
      (response: any) => {
        this.res = response;
        console.log("inside home module main data .............")

        this.getMenuList(this.queryParam.lang, this.res.menu);


        if (this.queryParam.id == '437' && this.queryParam.biller == 'TPAY') {
          let trendingCount = 0;
          let recomendedCount = 0;
          // debugger;
          for (let i = 0; i < this.res.contentmapping.length; i++) {
            if (this.res.contentmapping[i].cdm_url != '' && trendingCount <= 5) {
              if (this.res.contentmapping[i].cdm_content_path.includes("http://ginger.matrixads.in/repository/content/")) {
                this.trendingList.push(this.res.contentmapping[i]);

              } else {
                this.res.contentmapping[i].cdm_content_path = "http://ginger.matrixads.in/repository/content" + this.res.contentmapping[i].cdm_content_path;
                this.trendingList.push(this.res.contentmapping[i]);
              }
              trendingCount++;
            } else if (this.res.contentmapping[i].cdm_url == '' && this.res.contentmapping[i].cdm_content_path.includes('.mp4') && recomendedCount <= 3) {
              this.recommendList.push(this.res.contentmapping[i]);
              recomendedCount++;

            }
            if (trendingCount == 5 && recomendedCount == 3) {
              break;
            }
          }

        } else if (this.queryParam.id == '525' || this.queryParam.id == '528') {
          for (let i = 0; i < this.res.contentmapping.length; i++) {
            if (this.res.contentmapping[i].cdm_url != '') {
              if (i <= 4) {
                if (this.res.contentmapping[i].cdm_content_path.includes("http://ginger.matrixads.in/repository/content/")) {
                  this.trendingList.push(this.res.contentmapping[i]);
                } else {
                  this.res.contentmapping[i].cdm_content_path = "http://ginger.matrixads.in/repository/content" + this.res.contentmapping[i].cdm_content_path;
                  this.trendingList.push(this.res.contentmapping[i]);
                }
              }
              else if (i > 4 && i <= 8) {
                if (this.res.contentmapping[i].cdm_content_path.includes("http://ginger.matrixads.in/repository/content/")) {
                  this.recommendList.push(this.res.contentmapping[i]);
                } else {
                  this.res.contentmapping[i].cdm_content_path = "http://ginger.matrixads.in/repository/content" + this.res.contentmapping[i].cdm_content_path;
                  this.recommendList.push(this.res.contentmapping[i]);
                }
              }

            } else {
              if (i <= 4) {
                this.trendingList.push(this.res.contentmapping[i]);
              } else if (i > 4 && i <= 8) {
                this.recommendList.push(this.res.contentmapping[i]);
              }
            }

          }
        } else if (this.queryParam.id == '493' && this.queryParam.biller == 'IRAQCOM') {
          let apkCount = 0;
          let videoCount = 0;

          for (let i = 0; i < this.res.contentmapping.length; i++) {
            if (this.res.contentmapping[i].cdm_content_path.includes(".apk")) {
              if (apkCount < 2) {
                this.recommendList.push(this.res.contentmapping[i]);
                apkCount++;
              }
            } else if (this.res.contentmapping[i].cdm_content_path.includes(".mp4")) {
              if (videoCount < 2) {
                this.recommendList.push(this.res.contentmapping[i]);
                videoCount++;
              }
            }

            if (apkCount >= 2 && videoCount >= 2)
              break;


          }
        } else {
          for (let i = 0; i < this.res.contentmapping.length; i++) {

            if (i <= 4) {

              if (!this.res.contentmapping[i].cdm_content_path.includes('http')) {
                if (this.res.contentmapping[i].cdm_url == '') {
                  this.res.contentmapping[i].cdm_content_path = "https://1477157375.rsc.cdn77.org/repository/content" + this.res.contentmapping[i].cdm_content_path;

                } else {
                  this.res.contentmapping[i].cdm_content_path = "http://ginger.matrixads.in/repository/content" + this.res.contentmapping[i].cdm_content_path;

                }
                this.trendingList.push(this.res.contentmapping[i]);
              } else {
                this.res.contentmapping[i].cdm_content_path = this.res.contentmapping[i].cdm_content_path;
                this.trendingList.push(this.res.contentmapping[i]);
              }
            } else if (i > 4 && i <= 8) {

              if (!this.res.contentmapping[i].cdm_content_path.includes('http')) {
                if (this.res.contentmapping[i].cdm_url == '') {
                  this.res.contentmapping[i].cdm_content_path = "https://1477157375.rsc.cdn77.org/repository/content" + this.res.contentmapping[i].cdm_content_path;

                } else {
                  this.res.contentmapping[i].cdm_content_path = "http://ginger.matrixads.in/repository/content" + this.res.contentmapping[i].cdm_content_path;

                }
                this.recommendList.push(this.res.contentmapping[i]);
              } else {
                this.res.contentmapping[i].cdm_content_path = this.res.contentmapping[i].cdm_content_path;
                this.recommendList.push(this.res.contentmapping[i]);
              }
            }
          }


        }


        console.log(this.trendingList);
        console.log(this.recommendList);
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }



  getMenuList(lang: any, menuList: any) {
    // debugger;
    this.apiService.getMenus(menuList, lang).subscribe(
      (response: any) => {
        this.menu = response;
        if (this.menu.length > 0) this.getButtonCategories(this.menu[0].url);
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  getButtonCategories(url: any = '') {
    this.apiService.getCats(url).subscribe(
      (response: any) => {
        console.log('Category ===============', response);
        if (this.queryParam.id == '525' || this.queryParam.id == '528') {
          this.contentList = [];
          for (let i = 0; i < response.length; i++) {
            response[i].cdm_content_path = "http://ginger.matrixads.in/repository/content" + response[i].cdm_content_path;
            this.contentList.push(response[i]);
          }
        } else {
          //  this.contentList = response;

          this.contentList = [];
          for (let i = 0; i < response.length; i++) {
            if (!response[i].cdm_content_path.includes('http')) {
              if (response[i].cdm_url == '') {
                response[i].cdm_content_path = "https://1477157375.rsc.cdn77.org/repository/content" + response[i].cdm_content_path;

              } else {
                response[i].cdm_content_path = "http://ginger.matrixads.in/repository/content" + response[i].cdm_content_path;

              }
              this.contentList.push(response[i]);
            } else {
              response[i].cdm_content_path = response[i].cdm_content_path;
              this.contentList.push(response[i]);
            }

          }
        }

      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  downloadApk(url: any) {
    window.open(url, '_blank');

  }

  gotoHome(item: any) {

    if (!this.queryParam.msisdn) {
      this.DialogHutch();
      return;
    }

    if (this.gameConfig.name === 'game') {
      if (item.cdm_url === '') {
        if (item.cdm_content_path.includes('http')) {
          window.open(
            item.cdm_content_path,
            '_blank'
          );
        } else {
          window.open(
            'https://1477157375.rsc.cdn77.org/repository/content' +
            item.cdm_content_path,
            '_blank'
          );
        }

      } else {
        window.open(item.cdm_url, '_blank');
      }
    } else {
      if (item.cdm_content_path.includes('http')) {
        window.open(
          item.cdm_content_path,
          '_blank'
        );
      } else {
        window.open(
          'https://1477157375.rsc.cdn77.org/repository/content' +
          item.cdm_content_path,
          '_blank'
        );
      }
    }
    

  }

  getConfigData(data: any, lang: any, theme: any) {
    this.apiService.getConfigData(data, lang, theme).subscribe(
      (response: any) => {
        this.gameConfig = response;
        this.titleService.setTitle(this.gameConfig.header1);
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  openDialog(): void {

    const modalRef = this.modal.open(MobileDialogComponent, { size: 'md', backdrop: 'static', keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }


  DialogHutch(): void {

    const modalRef = this.modal.open(HutchpopupComponent, { size: 'md', backdrop: 'static', keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
    modalRef.componentInstance.iframeUrl = 'http://consent.hutch.lk/register-service/VA%3D%3DDA%3D%3Ddw%3D%3D';
  }


  openBlocker(): void {

    const modalRef = this.modal.open(BlockerComponent, { size: 'lg', backdrop: 'static', keyboard: false, windowClass: 'custom-modal' });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }
  openDialog_comviva(): void {

    const modalRef = this.modal.open(ComvivaDialogComponent, { size: 'md', backdrop: 'static', keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }

  getMobilePINRes(mobileNumber: number, pinNumber: number, operatorId: string, url: any) {
    this.apiService.getMobilePINResponse(url).subscribe(
      (response: any) => {
        console.log('Mobile Reponse ===============', response);
        if (response !== null) {
          this.queryParam.pin = pinNumber;
          this.queryParam.sub = true;
          this.queryParam.mobileNumber = mobileNumber;
          let storageName = this.queryParam.id + this.queryParam.operator + this.queryParam.biller;
          localStorage.setItem(storageName, JSON.stringify(this.queryParam));
        }
        else {
          if(this.queryParam.msisdn != null || this.queryParam.msisdn != undefined || this.queryParam.msisdn != 0){
            if(this.queryParam.msisdn.length >= 9){
              this.modal.dismissAll();
            }else{
              this.openLoginDialog();
            }   
          }
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  openLoginDialog(): void {

    const modalRef = this.modal.open(LoginDialogComponent, { size: 'md', backdrop: 'static', keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }

  portalIds = ['6', '16', '32', '48', '87', '149', '152', '170', '197',
    '200', '286', '295', '296', '298', '305', '320', '322',
    '325', '327', '334', '335', '364', '370', '371', '375', '376'];

  operatorIds = ['2032', '2150', '2209', '2022', '2049', '2050', '2025', '4464', '2217',
    '2104', '2105', '5573', '8966', '9073', '9071', '2009', '2010', '2032', '2150', '2209',
    '9038', '2022', '2028', '2029', '2049', '2050', '2212', '2213', '2214', '2215', '2216',
    '2217', '2218', '2103', '7803', '2100', '2151', '9032', '9041', '2032', '2150', '2209',
    '9038', '2050', '2032', '2150', '2209', '9038', '2216', '8966', '2026', '2032', '2150',
    '2209', '9038', '2032', '2150', '2209', '2049', '2104', '5573', '2009', '2010', '2032',
    '2150', '2209', '2049', '2050', '2216', '2104', '5573', '2001', '9038', '8966', '8899',
    '8903', '8966', '2215', '2216', '2217', '2217', '5573', '8903', '8966', '9041', '2032',
    '2150', '2209', '9038', '2029', '2213', '2217', '2104', '5573', '2009', '2010', '2032',
    '2150', '2209', '9038', '2028', '2049', '2050', '2213', '2214', '4464', '2215', '2216',
    '9042', '2104', '2105', '5573', '8899', '8903', '8966', '2032', '2150', '2032', '2150',
    '2032', '2150', '2209', '9038', '2215', '2216', '2104', '2105', '5573', '2032', '2150',
    '2209', '9038', '2215', '2216', '2104', '2105', '5573', '2032', '2032', '2150', '2209',
    '9038', '2049', '2050', '2215', '2216', '2104', '2105', '5573', '9071', '2032', '2150',
    '2209', '9038', '2049', '2050', '2215', '2216', '2104', '2105', '5573', '2010', '2032',
    '2150', '2209', '9038', '2029', '2049', '2050', '2215', '2216', '2104', '2105', '5573',
    '9071', '2032', '2150', '2209', '9038', '2032', '2150', '2209', '9038', '2104', '5573',
    '2216', '2104', '5573', '2104', '2032', '2150', '2209', '9038', '2049', '2050', '2049',
    '2050', '2049', '2050', '2032', '2150', '2209', '9038', '2032', '2150', '2209', '9038',
    '2010', '2032', '2150', '2209', '9038', '2010', '8899', '8903', '8966', '8899', '8903',
    '8966', '2032', '2150', '2209', '9038', '2032', '2150', '2209', '9038', '2032', '2150',
    '2209', '9038', '5573', '2026', '2216', '2216', '9073', '2049', '2050', '2032', '2150',
    '2209', '9038', '2032', '2150', '2209', '9038', '2001', '2215', '2102', '5518', '9047',
    '2102', '5518', '9047', '2104'];


  getConditionalDialogBox() {

    if (this.apiService.isRedirct(this.queryParam.id, this.queryParam.biller)) {
      if (this.queryParam.msisdn == undefined) {
        if (this.queryParam.id == '426') {
          window.location.href = "http://wap.matrixads.in/mglobopay/SMartFrenSSHEGetRequest?serviceId=" + 1209;
        } else if (this.queryParam.id == '273') {
          window.location.href = "http://wap.matrixads.in/mglobopay/SMartFrenSSHEGetRequest?serviceId=" + 1212;

        }
      }
    } else if ((this.queryParam.id === '369') && (this.queryParam.biller === 'fcc') && (this.queryParam.operator === '2028' )) {
      this.modal.dismissAll();
    }
    // else if(this.queryParam.id == '491' && this.queryParam.biller == 'MONDIOMEDIA' && this.queryParam.operator == '2108'){
    //   this.modal.dismissAll();
    // }
    else if (this.queryParam.id === '429' && this.queryParam.biller === 'Mobimind' && this.queryParam.operator === '8903') {
      this.modal.dismissAll();
    } else if ((this.queryParam.id === '298' || this.queryParam.id === '334') && this.queryParam.biller === 'TPAY' && this.queryParam.operator === "8966") {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openLoginDialog();
      } else {
        let url = "http://wap.globocom.info/mglobopay/tpayLoginByUsername?msisdn=" + this.queryParam.mobileNumber + "&pin=" + this.queryParam.pin + "&operatorId=" + this.queryParam.operator;
        this.getMobilePINRes(this.queryParam.mobileNumber, this.queryParam.pin, this.queryParam.operator, url)
      }
    } else if (this.portalIds.includes(this.queryParam.id) && this.queryParam.biller === 'TPAY' && this.operatorIds.includes(this.queryParam.operator)) {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openLoginDialog();
      } else {
        let url = "http://wap.globocom.info/mglobopay/tpayLoginByUsername?msisdn=" + this.queryParam.mobileNumber + "&pin=" + this.queryParam.pin + "&operatorId=" + this.queryParam.operator;
        this.getMobilePINRes(this.queryParam.mobileNumber, this.queryParam.pin, this.queryParam.operator, url)
      }
    }
    //  else if ((this.queryParam.id === '481') && this.queryParam.lang == 'EN' && this.queryParam.biller.toLowerCase() == ('ONE97').toLowerCase()) {
    //   if (this.queryParam.mobileNumber == 0) {
    //     this.queryParam.popup = true;
    //     // this.openDialog();
    //   } else {
    //     let url = "https://wap.matrixads.in/mglobopay/uaeONSSubscriptionStatus?msisdn=" + this.queryParam.mobileNumber;
    //     this.getMobileRes(this.queryParam.mobileNumber, url)
    //   }
    // }
    else if ((this.queryParam.id == '401') && this.queryParam.biller.toLowerCase() == "ALTRUS".toLowerCase()) {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openDialog();
      } else {
        let url = "http://wap.matrixads.in/mglobopay/altrusCheckSubscriptionStatus?msisdn=" + this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    } else if ((this.queryParam.id == '297') && this.queryParam.biller.toLowerCase() == "MediaWorld".toLowerCase()) {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openDialog();
      } else {
        this.setValuesToLocalStorage(this.queryParam.mobileNumber)
      }
    } else if ((this.queryParam.id == '453' || this.queryParam.id == '454') && (this.queryParam.biller.toLowerCase() == "MTNMONEY".toLowerCase())) {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openDialog();
      } else {
        let url = "https://wap.matrixads.in/mglobopay/fetchMTNBeninSubscriptionStatus/" + this.queryParam.serviceId + "/" + this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    } else if ((this.queryParam.id == '420' || this.queryParam.id == '421') && this.queryParam.biller.toLowerCase() == "AirtelMoney".toLowerCase()) {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openDialog();
      } else {
        let url = "https://wap.matrixads.in/mglobopay//fetchAirtelNigerSubscriptionStatus/" + this.queryParam.serviceId + "/" + this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    } else if ((this.queryParam.id == '416') || this.queryParam.biller.toLowerCase() == "MediaWorld".toLowerCase()) {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;

        this.openDialog();

      } else {
        let url = "http://wap.matrixads.in/mglobopay/mediaWorldSubscriptionStatus/" + this.queryParam.serviceId + "/" + this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    } else if ((this.queryParam.id == '490' || this.queryParam.id == '427' || this.queryParam.id == '526') && this.queryParam.biller.toLowerCase() == "SLADigital".toLowerCase()) {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openDialog();
      } else {
        if ((this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') && this.queryParam.id == '490') {
          this.queryParam.serviceId = "1319";
        } else if ((this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') && this.queryParam.id == '427') {
          this.queryParam.serviceId = "1321";
        } else if ((this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') && this.queryParam.id == '526') {
          this.queryParam.serviceId = "1313";
        }
        let url = "http://wap.matrixads.in/mglobopay/SlaDigitalSubscriptionStatus?msisdn=" + this.queryParam.msisdn + "&serviceId=" + this.queryParam.serviceId;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    } else if (this.queryParam.id === '6' && this.queryParam.biller === 'TPAY' && (this.queryParam.operator === "9071" || this.queryParam.operator === "9073")) {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openDialog();
      } else {
        let url = "http://wap.matrixads.in/mglobopay/tpaygamesworldPortalValidation/" + this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    } else if (this.queryParam.id === '447' && this.queryParam.biller === 'SLADigital' && (this.queryParam.operator === "2029")) {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openDialog();
      } else {
        // let url = "http://wap.matrixads.in/mglobopay/tpaygamesworldPortalValidation/"+this.queryParam.mobileNumber;
        // return "http://wap.matrixads.in/mglobopay/getSubDataById?serviceid=1313&msisdn=2585537895";
        // this.queryParam.serviceId = '1349';
        let url = "http://wap.matrixads.in/mglobopay/getSubDataById?serviceid=" + this.queryParam.serviceId + "&msisdn=" + mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url);
      }
    }
    // else if((this.queryParam.id === '519' || '530' || '447') && this.queryParam.biller === 'COMVIVA' && (this.queryParam.operator === '2022' ) ){
    //   if(this.queryParam.mobileNumber == 0){
    //     this.queryParam.popup = true;
    //     this.openDialog_comviva();
    //   }else{
    //     let url =  "http://wap.matrixads.in/mglobopay/getSubDataById?serviceid="+this.queryParam.serviceId+"&msisdn="+mobileNumber;
    //     this.getMobileRes(this.queryParam.mobileNumber, url);
    //     console.log("UNSUB DATA",url)
    //   }
    // }
    else if ((this.queryParam.id === '532' ||this.queryParam.id == '563') && (this.queryParam.biller.toLowerCase() == 'Sunych'.toLowerCase() || this.queryParam.biller.toLowerCase() == 'Mobimind') && (this.queryParam.operator == '2135' || this.queryParam.operator == '2025')) {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        // this.openDialog();
      } else {

        let url = "http://103.127.157.215:8080/mglobopay/getSubDataById?serviceid=" + this.queryParam.serviceId + "&msisdn=" + mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url);
      }
    }else if(this.queryParam.id === '16' && this.queryParam.biller === 'TRENDYTECH'){
      this.openDialog();
    }
  }

  getQueryParam() {

    // this.queryParam = {} as QueryParam;
    this.queryParam.theme = 1;
    this.queryParam.popup = false;
    this.queryParam.mobileNumber = 0;
    this.queryParam.sub = false;
    this.activatedRoute.queryParams.subscribe(params => {
      if (typeof params['id'] != undefined && params['id'] != null) {
        this.queryParam.id = params['id'];
      }
      if (typeof params['lang'] != undefined && params['lang'] != null) {
        this.queryParam.lang = params['lang'];
      }

      if (typeof params['code'] != undefined && params['code'] != null) {
        this.queryParam.code = params['code'];
      }

      if (
        typeof params['categoryid'] != undefined &&
        params['categoryid'] != null
      ) {
        this.queryParam.categoryid = params['categoryid'];
      }
      if (
        typeof params['operator'] != undefined &&
        params['operator'] != null
      ) {
        this.queryParam.operator = params['operator'];
      }
      if (typeof params['biller'] != undefined && params['biller'] != null) {
        this.queryParam.biller = params['biller'];
      }
      if (typeof params['theme'] != undefined && params['theme'] != null) {
        this.queryParam.theme = params['theme'];
      }
      if (typeof params['msisdn'] != undefined && params['msisdn'] != null) {
        this.queryParam.msisdn = params['msisdn'];
      }
      if (typeof params['country'] != undefined && params['country'] != null) {
        this.queryParam.country = params['country'];
      }
      if (typeof params['cid'] != undefined && params['cid'] != null) {
        this.queryParam.cid = params['cid'];
      }
      if (typeof params['msisdn'] != undefined && params['msisdn'] != null) {
        this.queryParam.mobileNumber = params['msisdn'];
      }


      if (typeof params['subscription_id'] != undefined && params['subscription_id'] != null) {
        this.queryParam.subscription_id = params['subscription_id'];
      }

      if (typeof params['operator_name'] != undefined && params['operator_name'] != null) {
        this.queryParam.operator_name = params['operator_name'];
      }


      if (typeof params['service_id'] != undefined && params['service_id'] != null) {
        this.queryParam.serviceId = params['service_id'];
      }

      if (typeof params['serviceid'] != undefined && params['serviceid'] != null) {
        this.queryParam.serviceid = params['serviceid'];
      }

      if (typeof params['serviceId'] != undefined && params['serviceId'] != null) {
        this.queryParam.serviceId = params['serviceId'];
      }

      if (typeof params['serviceName'] != undefined && params['serviceName'] != null) {
        this.queryParam.serviceName = params['serviceName'];
      }
      if (typeof params['blocker'] != undefined && params['blocker'] != null) {
        this.queryParam.blocker = params['blocker'];
      }
    });
  }

}

function mobileNumber(mobileNumber: any) {
  throw new Error('Function not implemented.');
}

